import { render, staticRenderFns } from "./default-cart-item.vue?vue&type=template&id=fa5c5b22&scoped=true"
import script from "./default-cart-item.vue?vue&type=script&lang=js"
export * from "./default-cart-item.vue?vue&type=script&lang=js"
import style0 from "./default-cart-item.vue?vue&type=style&index=0&id=fa5c5b22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5c5b22",
  null
  
)

export default component.exports